import React, { useEffect, useRef } from 'react';
import Dropzone from 'dropzone';
import 'dropzone/dist/dropzone.css';
import '../styles/formularios.css';
import '../styles/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logoInstituto from '../components/images/logo.png';
import logoSEP from '../components/images/SEP_Logo_2019.svg.png';
import { Link } from 'react-router-dom';
import { useLocation, useNavigate } from 'react-router-dom';


Dropzone.autoDiscover = false;

const RegistrarEvidencias = () => {
  const dropzoneRef = useRef(null);
  const navigate = useNavigate();
    const location = useLocation();
    const handleSalir = () => {
      const rol = resolveRolBase(location.pathname);
      if (rol) {
        navigate(`/${rol}/inicio`, { replace: true });
      } else {
        // Fallback por si no se detecta rol ni en path ni en localStorage:
        navigate('/inicio', { replace: true });
      }
    };
  useEffect(() => {
    if (dropzoneRef.current && Dropzone.instances.length === 0) {
      const dz = new Dropzone(dropzoneRef.current, {
        url: '/fake-url',
        autoProcessQueue: false,
        maxFilesize: 5,
        acceptedFiles: '.jpg,.png,.jpeg,.pdf,.docx,.xlsx,.pptx',
        addRemoveLinks: true,
        dictDefaultMessage: 'Arrastra y suelta tus archivos aquí o haz clic para seleccionarlos.',
        init: function () {
          this.on('addedfile', function (file) {
            const ext = file.name.split('.').pop().toLowerCase();
            if (ext === 'pdf')
              this.emit('thumbnail', file, 'https://cdn-icons-png.flaticon.com/512/337/337946.png');
            if (ext === 'docx' || ext === 'doc')
              this.emit('thumbnail', file, 'https://cdn-icons-png.flaticon.com/512/281/281760.png');
            if (ext === 'xlsx' || ext === 'xls')
              this.emit('thumbnail', file, 'https://cdn-icons-png.flaticon.com/512/888/888879.png');
            if (ext === 'pptx' || ext === 'ppt')
              this.emit('thumbnail', file, 'https://cdn-icons-png.flaticon.com/512/888/888857.png');
          });
        },
      });

      return () => dz.destroy(); // limpieza al desmontar
    }
  }, []);

  return (
    <div className="container py-4 px-4">
      {/* Encabezado */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <img src={logoInstituto} alt="Logo Instituto" className="logo" />
        <div className="flex-grow-1 text-center">
          <h4 className="mb-0">Instituto Silviano Carrillo</h4>
          <small className="text-muted fs-5">Registrar Evidencias</small>
        </div>
        <img src={logoSEP} alt="Logo SEP" className="logo" />
      </div>

      {/* Formulario */}
      <div className="p-4 bg-light rounded shadow-sm">
        <form className="row g-3" id="formularioEvidencias">
          <div className="col-md-4">
            <label htmlFor="idEvidencia" className="form-label">ID Evidencias</label>
            <input type="text" className="form-control" id="idEvidencia" />
          </div>

          <div className="col-md-8">
            <label htmlFor="descripcion" className="form-label">Descripción</label>
            <input type="text" className="form-control" id="descripcion" />
          </div>

          <div className="col-md-6">
            <label htmlFor="temaPlaneacion" className="form-label">Tema de Planeación</label>
            <select id="temaPlaneacion" className="form-select">
              <option disabled selected>Seleccionar</option>
              <option value="1">Matemáticas - Tema 1</option>
              <option value="2">Español - Tema 2</option>
              <option value="3">Ciencias - Tema 3</option>
            </select>
          </div>

          <div className="col-12">
            <label className="form-label">Subir Evidencias (imágenes, archivos, links)</label>
            <div id="dropzonePlaneaciones" className="dropzone" ref={dropzoneRef}></div>
          </div>
          {/* Botones */}
          <div className="d-flex justify-content-center gap-3 mt-4">
            <button className="btn btn-success px-4">Registrar</button>
            <button type="button" className="btn btn-danger px-4" onClick={handleSalir}>
             Salir
            </button>
          </div>
        </form> 
      </div>

      

      {/* Datos ocultos */}
      <form id="formEvidencia" style={{ display: 'none' }}>
        <input type="hidden" name="idEvidencia" value="1" />
        <input type="hidden" name="idPlaneacion" value="5" />
      </form>
    </div>
  );
};

/* ----------------- Helper para detectar el rol ----------------- */
function resolveRolBase(pathname) {
  // 1) Intenta desde la URL actual
  const roles = ['directora', 'coordinadora', 'docente', 'alumno'];
  const seg = pathname.split('/').filter(Boolean)[0];
  if (roles.includes(seg)) return seg;

  // 2) Respaldo desde localStorage.role (números mapeados a slugs)
  const roleId = Number(localStorage.getItem('role'));
  const map = { 1: 'directora', 2: 'coordinadora', 3: 'docente', 4: 'alumno' };
  return map[roleId] || null;
}

export default RegistrarEvidencias;
